// src/js/main/questionGuide.js

import { initializeGuideTooltip } from '../components/guideTooltipHandler.js';

function initializeGuide() {

    const modeButtons = document.querySelectorAll('.segmented-control__button');
    const filterButtons = document.querySelectorAll('.filter-btn');
    const resultsList = document.querySelector('.results-list');
    
    if (!resultsList || modeButtons.length === 0 || filterButtons.length === 0) return;

    const resultItems = Array.from(resultsList.querySelectorAll('.result-item'));
    let isMultiSelectMode = false;
    const activeFilters = new Set();

    function applyFiltersAndAnimate() {
        // ... (Din befintliga, komplexa logik för att filtrera och animera. Den är bra och behöver inte ändras.)
        const firstPositions = new Map();
        resultItems.forEach(item => {
            if (!item.parentElement) return;
            firstPositions.set(item, item.getBoundingClientRect());
        });

        resultItems.sort((a, b) => {
            const aCategories = new Set(a.dataset.categories.split(' '));
            const bCategories = new Set(b.dataset.categories.split(' '));
            const aIsActive = activeFilters.size === 0 || [...activeFilters].some(f => aCategories.has(f));
            const bIsActive = activeFilters.size === 0 || [...activeFilters].some(f => bCategories.has(f));
            if (aIsActive && !bIsActive) return -1;
            if (!aIsActive && bIsActive) return 1;
            return a.textContent.localeCompare(b.textContent);
        });

        resultItems.forEach(item => {
            const itemCategories = new Set(item.dataset.categories.split(' '));
            const shouldShow = activeFilters.size === 0 || [...activeFilters].some(f => itemCategories.has(f));
            item.classList.toggle('is-hidden', !shouldShow);
            resultsList.appendChild(item);
        });

        resultItems.forEach(item => {
            const lastPosition = item.getBoundingClientRect();
            const firstPosition = firstPositions.get(item);
            if (!firstPosition) return;
            const deltaX = firstPosition.left - lastPosition.left;
            const deltaY = firstPosition.top - lastPosition.top;
            
            if (deltaX === 0 && deltaY === 0) return;

            item.style.transform = `translate(${deltaX}px, ${deltaY}px)`;
            item.style.transition = 'transform 0s';
        });

        requestAnimationFrame(() => {
            resultItems.forEach(item => {
                item.style.transition = 'transform 0.5s ease, opacity 0.5s ease';
                item.style.transform = '';
            });
        });
    }
    
    modeButtons.forEach(button => {
        button.addEventListener('click', () => {
            if (button.classList.contains('active')) return;
            modeButtons.forEach(btn => btn.classList.remove('active'));
            button.classList.add('active');
            isMultiSelectMode = button.dataset.mode === 'multi';
            
            activeFilters.clear();
            filterButtons.forEach(btn => btn.classList.remove('active'));
            applyFiltersAndAnimate();
        });
    });

    filterButtons.forEach(button => {
        button.addEventListener('click', () => {
            const filter = button.dataset.filter;
            if (isMultiSelectMode) {
                button.classList.toggle('active');
                if (activeFilters.has(filter)) {
                    activeFilters.delete(filter);
                } else {
                    activeFilters.add(filter);
                }
            } else {
                const isAlreadyActive = button.classList.contains('active');
                filterButtons.forEach(btn => btn.classList.remove('active'));
                activeFilters.clear();
                if (!isAlreadyActive) {
                    button.classList.add('active');
                    activeFilters.add(filter);
                }
            }
            applyFiltersAndAnimate();
        });
    });
    
    applyFiltersAndAnimate(); // Kör en gång vid start
    console.log('Question Guide initialized.');
}

document.addEventListener('DOMContentLoaded', () => {
    initializeGuide();
    initializeGuideTooltip();
});